// extracted by mini-css-extract-plugin
export default {"token-table-row":"Y93aDNd8msOywbVIn_0W","token-expired":"DBPhgzvKeFbVrR9qktB_","delete-button":"IHBaCWq6HehORNrL9Dgj"};